var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77466 0.52124H37.2254C39.4656 0.52124 41.2817 2.33732 41.2817 4.57758V28.9156C41.2817 31.1559 39.4656 32.9719 37.2254 32.9719H4.77466C2.53441 32.9719 0.718323 31.1559 0.718323 28.9156V4.57758C0.718323 2.33732 2.53441 0.52124 4.77466 0.52124ZM4.77466 2.54941C3.65453 2.54941 2.74649 3.45745 2.74649 4.57758V28.9156C2.74649 30.0357 3.65453 30.9438 4.77466 30.9438H37.2254C38.3455 30.9438 39.2535 30.0357 39.2535 28.9156V4.57758C39.2535 3.45745 38.3455 2.54941 37.2254 2.54941H4.77466ZM21 16.5068L33.5867 6.79971C34.0396 6.47029 34.6738 6.57043 35.0032 7.02338C35.3327 7.47632 35.2325 8.11055 34.7796 8.43996L21.5965 18.5808C21.2409 18.8394 20.7591 18.8394 20.4036 18.5808L7.22046 8.43996C6.76752 8.11055 6.66737 7.47632 6.99679 7.02338C7.3262 6.57043 7.96043 6.47029 8.41337 6.79971L21 16.5068Z",
    fill: "#B2C4C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bed4eb233ead86136a38e372666a0ac3.svg";
export { ForwardRef as ReactComponent };